import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // 1. Baidu Tongji Manual Track
    if (window._hmt) {
      const fullPath = location.pathname + location.search;
      window._hmt.push(['_trackPageview', fullPath]);
    }

    // 2. Microsoft Clarity (Bing)
    // Note: Clarity usually tracks SPAs automatically, but calling 
    // a manual 'set' ensures data consistency between the two platforms.
    if (window.clarity) {
      window.clarity("set", "page_path", location.pathname);
    }
  }, [location]);
};

export default useAnalytics;